import React from "react";
import "./Footer.scss";
import Icon from "react-icons-kit";
import { linkedin } from "react-icons-kit/fa/linkedin";
import { youtubePlay } from "react-icons-kit/fa/youtubePlay";
import { instagram } from "react-icons-kit/fa/instagram";
import JejakinLogoDarky from "./../../../images/jejakin-icon-dark.svg";
import { useTranslation } from "react-i18next";

function Footer(props) {
  const { i18n } = useTranslation();
  var language = window.localStorage.i18nextLng;

  function switchLanguage(lang) {
    language = lang;
    var url = window.location.href;
    i18n.changeLanguage(lang);
    if (url.includes("?")) {
      url = url.split("?")[0] + "?user_locale=" + lang;
    } else {
      url = url.split("?")[0] + "?user_locale=" + lang;
    }
    localStorage.setItem("language", lang);
    setTimeout(function () {
      window.location.href = url;
    }, 100);
  }
  return (
    <div className="footer no-print">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-sm-12">
            <div className="row no-gutters align-items-center row-copyright">
              <div className="col-auto">
                <img src={JejakinLogoDarky} alt="Jejakin" />
              </div>
              <div className="col-auto">
                <div className="copyright">
                  <p>&copy; 2023 Jejakin - All rights reserved</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <div className="wrap-footer-link">
              <div className="wrap-sosmed">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/company/jejak-in/"
                >
                  <Icon size={24} icon={linkedin} />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://bit.ly/JejakinChannel"
                >
                  <Icon size={24} icon={youtubePlay} />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/jejak_in/"
                >
                  <Icon size={24} icon={instagram} />
                </a>
              </div>
              <div className="wrap-lang">
                <span
                  className={
                    language === "id"
                      ? "btn-lang btn-bahasa active "
                      : "btn-lang btn-bahasa"
                  }
                  onClick={() => switchLanguage("id")}
                >
                  BAHASA
                </span>
                <span
                  className={
                    language === "en"
                      ? "btn-lang btn-english active "
                      : "btn-lang btn-english"
                  }
                  onClick={() => switchLanguage("en")}
                >
                  ENGLISH
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
